import { jsxs, jsx } from "react/jsx-runtime";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
const BottomNavigation = ({ classes, className, children }) => {
  const { themeClasses } = useThemePresetClasses("BottomNavigation", classes, className);
  return /* @__PURE__ */ jsxs("div", { className: cn("relative h-[56px]", themeClasses == null ? void 0 : themeClasses.root, className), children: [
    /* @__PURE__ */ jsx("div", { className: "absolute left-0 top-0 h-[1px] w-full bg-[rgba(255,255,255,0.02)]" }),
    /* @__PURE__ */ jsx("nav", { className: cn("", themeClasses == null ? void 0 : themeClasses.container), children })
  ] });
};
const BottomNavigation$1 = BottomNavigation;
export {
  BottomNavigation$1 as default
};
